import React, { useEffect, useState } from 'react';
import { IoMdRefresh } from 'react-icons/io';

function Captcha({ onValidate }) {
    const [captcha, setCaptcha] = useState('');
    const [userCaptcha, setUserCaptcha] = useState('');
    const [captchaError, setCaptchaError] = useState('');

    const generateCaptcha = () => {
        return Math.random().toString(36).substring(2, 8);
    };

    useEffect(() => {
        setCaptcha(generateCaptcha());
    }, []);

    // ✅ validate function (called manually)
    const validate = () => {
        if (userCaptcha !== captcha) {
            setCaptchaError('Invalid captcha');
            return false;
        }

        setCaptchaError('');
        return true;
    };

    // expose validation to parent
    useEffect(() => {
        if (onValidate) {
            onValidate(validate);
        }
    }, [userCaptcha, captcha]);

    return (
        <div className="grid grid-cols-2 gap-4 mt-4">

            <div className="col-span-1">
                <div className="flex  items-center">

                    <div className='w-[210px]'>


                        <div className="bg-gray-200 p-2 text-lg font-bold  text-red-800 text-center tracking-[1em]">
                            {captcha}
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={() => {
                            setCaptcha(generateCaptcha());
                            setUserCaptcha('');
                            setCaptchaError('');
                        }}
                        className="text-blue-500 text-sm mt-1 ml-3 btn btn-md  bg-gray-600 text-white text-xl hover:bg-red-900"
                    >
                        <IoMdRefresh />
                    </button>
                </div>



            </div>

            <div className="col-span-1">


                <input
                    type="text"
                    value={userCaptcha}
                    placeholder='Enter Captcha'
                    onChange={(e) => setUserCaptcha(e.target.value)}
                    className="input input-bordered input-md w-full mt-2"
                />

                {captchaError && (
                    <p className="text-red-500 text-xs mt-1">{captchaError}</p>
                )}




            </div>


        </div>
    );
}

export default Captcha;